import React, { useState } from 'react';
import { ClickAwayListener, Tooltip, Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { TypographyCheckSell } from '../style/typography';
import { CheckboxCell } from '../style/tablecell';

export const TooltipCheckboxCell = ({ cellLabel, tooltipContent, subLabel }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleTooltipToggle = () => {
    setTooltipOpen(!tooltipOpen);
  };

  const handleTooltipClose = () => {
    setTooltipOpen(false);
  };

  return (
    <CheckboxCell>
      <ClickAwayListener onClickAway={handleTooltipClose}>
        <span style={{ display: "flex", alignItems: "center" }}>
          <Tooltip
            open={tooltipOpen}
            onClose={handleTooltipClose}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title={
              <span style={{ fontSize: '0.8rem' }}>
                {tooltipContent}
              </span>
            }
            arrow
            placement="top-start"
          >
            <InfoOutlinedIcon
              fontSize="small"
              onClick={handleTooltipToggle}
              sx={{ marginRight: 0.5, cursor: "pointer", color: "#0A7CB7" }}
            />
          </Tooltip>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <TypographyCheckSell>{cellLabel}</TypographyCheckSell>
            {subLabel && (
              <Typography
                sx={{
                  color: 'red',
                  fontSize: '0.7rem',
                  fontWeight: 'bold',
                  lineHeight: 1.2,
                  marginTop: '2px'
                }}
              >
                {subLabel}
              </Typography>
            )}
          </Box>
        </span>
      </ClickAwayListener>
    </CheckboxCell>
  );
};

export default TooltipCheckboxCell;